/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { UnmountClosed } from 'react-collapse';
import { ICONS } from 'Components/utils/icon/icons';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  clientName: string;
  lastVisitsLabel: string;
  lastVisits: Array<{
    category: Array<string>;
    name: string;
  }>;
};
export const ThreeSixty = ({ clientName, lastVisitsLabel, lastVisits }: Props) => {
  const [isOpened, toggleThreeSixty] = useState<boolean>(false);
  return (
    <div
      className={classnames(
        'fixed top-[25%] z-4 mx-15 bg-gradient-to-br from-[#235472] to-[#a6dade] p-2 shadow transition-rounded duration-250 ease-in',
        {
          'rounded-pill': !isOpened,
          rounded: isOpened,
        },
      )}
    >
      <div
        className={classnames(
          'relative min-h-60 bg-white p-20 transition-all duration-250 ease-in',
          {
            'w-100 rounded-pill': !isOpened,
            'w-[256px] rounded-12': isOpened,
          },
        )}
        data-testid="ThreeSixty-content"
        onClick={() => toggleThreeSixty(!isOpened)}
      >
        <div className="flex h-24 items-center">
          <svg
            className="ThreeSixty-cxoLogo block h-auto w-56 shrink-0"
            width="130px"
            height="60px"
            viewBox="0 0 130 60"
            version="1.1"
          >
            <defs>
              <linearGradient
                x1="44.7159195%"
                y1="50%"
                x2="75.035875%"
                y2="50%"
                id="linearGradient-1"
              >
                <stop stopColor="#235472" offset="0%" />
                <stop stopColor="#A6DADE" offset="100%" />
              </linearGradient>
            </defs>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="10-B2B/Desktop/01-1_CXO" transform="translate(0.000000, -403.000000)">
                <g id="Group-2" transform="translate(0.000000, 403.160714)">
                  <path
                    d="M71.2064596,29.6873674 L85.6177833,42.8646077 C90.4453086,46.8799323 94.6046143,49.5481129 100.552511,49.5481129 C111.547972,49.5481129 120.461554,40.7137316 120.461554,29.81597 C120.461554,18.9182085 111.547972,10.0838272 100.552511,10.0838272 C94.4637587,10.0838272 89.1245616,12.6929064 85.219571,16.8145493 L71.2064596,29.6873674 Z M64.84932,23.3302278 L77.7054691,11.0848976 C84.1408993,4.71799111 91.2565906,0.502982484 100.390844,0.502982484 C116.691308,0.502982484 129.905444,13.7171187 129.905444,30.0175819 C129.905444,46.318045 116.691308,58.2393852 100.390844,58.2393852 C90.5625021,58.2393852 85.6177833,56.1114281 76.0119282,47.4843048 L64.3463874,36.5474396 L55.5310792,45.6122108 L48.7298497,38.8109814 L57.5340046,29.7350568 L47.9798065,20.32894 L54.9139193,13.3948271 L64.84932,23.3302278 Z M49.9291515,8.41005929 L42.9950386,15.3441722 C39.4697613,12.110536 34.7699391,10.0838272 29.6091556,10.0838272 C18.66937,10.0838272 9.80092149,19.0053746 9.80092149,29.9451602 C9.80092149,40.8849458 18.66937,48.7579875 29.6091556,48.7579875 C34.7678471,48.7579875 39.4659509,47.7813842 42.990751,44.5500801 L49.7919804,51.3513095 C44.5137473,56.3000378 37.4153607,59.3305694 29.6091556,59.3305694 C13.3086924,59.3305694 0.0945561695,46.1164332 0.0945561695,29.81597 C0.0945561695,13.5155069 13.3086924,0.301370651 29.6091556,0.301370651 C37.483187,0.301370651 44.6370464,3.38479421 49.9291515,8.41005929 Z"
                    id="Shape"
                    fill="url(#linearGradient-1)"
                  />
                  <path
                    d="M104.611739,34.6884892 L102.092025,37.2082036 L104.611739,39.7279181 L107.131453,37.2082036 L104.611739,34.6884892 Z M106.214867,18.7758278 C106.099844,18.2043091 104.726762,19.005873 101.750551,21.6370156 C102.893589,22.8950756 103.468702,22.2085343 104.496716,21.8670609 C105.29828,23.2401435 105.528326,29.764083 100.607514,31.7122788 C100.722537,25.1883392 100.837559,18.2043091 100.837559,18.2043091 C100.722537,18.0892865 100.607514,18.0892865 100.492491,18.0892865 C99.1194087,18.3193317 96.7147169,20.6090009 94.8815438,22.6686248 C95.9131529,24.3867753 97.1712129,22.7836474 98.2028221,22.4385795 C98.2028221,22.6686248 97.9727768,27.4744139 98.0877995,32.3988201 C93.0519651,32.7402935 93.853529,22.4385795 94.0799798,21.1805196 C94.1950025,20.0374822 90.8737241,22.4385795 89.1591681,23.9266848 C89.7306868,24.8432713 90.4172281,24.7282487 91.3338146,24.3831808 C90.9887468,28.9625191 94.1950025,33.1967896 98.0877995,33.0817669 C98.2028221,37.8911505 98.7743408,42.4668943 100.147423,42.8119622 C100.377469,42.8119622 100.492491,38.0025787 100.603919,32.5102483 C109.651168,29.764083 106.214867,18.7758278 106.214867,18.7758278 Z"
                    id="Shape"
                    fill="#005589"
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </svg>
          {isOpened && <Icon className="ms-auto cursor-pointer" name={ICONS.CROSS} width="16px" />}
        </div>
        <UnmountClosed
          theme={{
            content: 'w-[214px]',
          }}
          isOpened={isOpened}
        >
          <div className="py-25 text-20" data-testid="ThreeSixty-clientName">
            {clientName}
          </div>
          <div className="pb-15 text-14 text-black">{lastVisitsLabel}</div>
          <div className="space-y-10">
            {lastVisits.map((lastVisit, index) => (
              <div
                key={lastVisit.name + index}
                className="flex-end flex"
                data-testid="ThreeSixty-lastVisit"
              >
                <div>{lastVisit.name}</div>
                <div className="whitespace-nowrap">
                  <span>&nbsp;-&nbsp;</span>
                  {lastVisit.category.join(' / ')}
                </div>
              </div>
            ))}
          </div>
        </UnmountClosed>
      </div>
    </div>
  );
};
